export default __webpack_public_path__ + "static/media/custom-orders-active.eb50fd84.svg";